"use client";

import { motion } from "motion/react";
import { useEffect, useState } from "react";
import { Loader, Progress } from "visuais";
import { useLoadingFlow, LOADING_STEPS } from "@/_modulos/loading";

export default function IntranetLanding() {
  const [isClient, setIsClient] = useState(false);
  const { loadingState, startLoadingFlow } = useLoadingFlow();

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    if (isClient) {
      startLoadingFlow();
    }
  }, [isClient, startLoadingFlow]);

  return (
    <div className="relative h-[calc(100vh-84px)] w-full bg-background overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0">
        {/* Floating Orbs */}
        {isClient &&
          [...Array(20)].map((_, i) => (
            <motion.div
              key={i}
              className="absolute w-2 h-2 bg-cyan-400/20 rounded-full"
              initial={{
                x:
                  Math.random() *
                  (typeof window !== "undefined" ? window.innerWidth : 1200),
                y:
                  Math.random() *
                  (typeof window !== "undefined" ? window.innerHeight : 800),
              }}
              animate={{
                y: [0, -200, 0],
                opacity: [0, 1, 0],
                scale: [0, 1, 0],
              }}
              transition={{
                duration: Math.random() * 6 + 4,
                repeat: Infinity,
                delay: Math.random() * 4,
                ease: "easeInOut",
              }}
            />
          ))}

        {/* Large Gradient Orbs */}
        <motion.div
          className="absolute top-1/3 left-1/3 w-96 h-96 bg-gradient-to-r from-cyan-500/30 to-blue-500/30 rounded-full blur-3xl"
          animate={{
            scale: [1, 1.5, 1],
            opacity: [0.2, 0.5, 0.2],
            rotate: [0, 180, 360],
          }}
          transition={{
            duration: 8,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
        <motion.div
          className="absolute bottom-1/3 right-1/3 w-80 h-80 bg-gradient-to-r from-blue-500/30 to-cyan-500/30 rounded-full blur-3xl"
          animate={{
            scale: [1.2, 1, 1.2],
            opacity: [0.3, 0.6, 0.3],
            rotate: [360, 180, 0],
          }}
          transition={{
            duration: 10,
            repeat: Infinity,
            ease: "easeInOut",
            delay: 2,
          }}
        />
      </div>

      {/* Main Content */}
      <div className="relative z-10 flex items-center justify-center h-full">
        <div className="text-center">
          <p className="text-mutedforeground text-5xl font-bold mb-4">
            Bem vindo ao RodoApp
          </p>
          {/* Logo with Integrated Progress */}
          <motion.div
            className="relative"
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, ease: "easeOut" }}
          >
            <motion.div
              className="inline-block relative"
              animate={{
                rotate: [0, 5, 15, 0],
                scale: [1, 1.05, 1],
              }}
              transition={{
                duration: 4,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            >
              <Loader className="size-112" speed={0.5} />
            </motion.div>
          </motion.div>

          {/* Loading Text */}
          <motion.div
            className="mb-8"
            key={loadingState.currentStep}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="text-2xl font-bold text-foreground mb-4">
              {loadingState.error ? (
                <span className="text-red-400">Erro: {loadingState.error}</span>
              ) : (
                (() => {
                  const steps = Object.values(LOADING_STEPS);
                  const currentStep = steps[loadingState.currentStep];
                  return currentStep?.label || "Carregando...";
                })()
              )}
            </h2>

            {/* Progress Bar */}
            <div className="w-64 mx-auto">
              <Progress value={loadingState.progress} className="h-2" />
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
